// Bootstrapping module
import "core-js/modules/es7.object.values";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.array.from";

import React from 'react';
import ReactDOM from 'react-dom';
import Router from 'react-router';
import last = require("lodash/last")
import values = require("lodash/values")
import {routes, PageDefProps} from 'routes';

import commonService from 'core/common/service/commonService';
import uiService from 'core/common/service/uiService';

console.log('__ENVIRONMENT__ = ' + __ENVIRONMENT__);





// router

Router.run(routes as any, Router.HistoryLocation, (Root: any, state) => {

  console.debug('router run');
  commonService.emitter.emit('loadStart');

  const routes: PageDefProps[] = state.routes as any;
  const lastRoute: PageDefProps = routes[routes.length - 1] as any;

  if (lastRoute) {
    let title = lastRoute.handler.title;
    if (title) {
      document.title = title;
    }
  }

  let previousLastRoute: PageDefProps = last(Root.getCurrentRoutes()) as any;
  if (previousLastRoute && lastRoute) {
    uiService.updateTransition({params: Root.getCurrentParams(), query: Root.getCurrentQuery(), newQuery: state.query,
      routeName: previousLastRoute.name, newRouteName: lastRoute.name, rootPage: previousLastRoute.handler.rootPage});
  }


  const promises = routes.filter((route: PageDefProps) => route.handler.fetchData)
    .reduce((promises, route: PageDefProps) => {
      promises[route.name] = route.handler.fetchData(state.params, state.query);
      return promises;
    }, {});

  Promise.all(values(promises))
    .then((dataArray) => {
        ReactDOM.render(<Root {...state}/>, document.getElementById('root'));
    });

});



// WEBPACK FOOTER //
// ./src/module.tsx